import { Capacitor } from "@capacitor/core"
import { FusionError, serializeFusionError, SettingId } from '@fusion-advantage/backcompat'
import { SettingPersistRow, settingShouldPersistToLocalStorage } from "../lib/setting"
import { err, ok, Result } from "neverthrow"
import { selectLdbSettings, updateLdbSettings } from "../dal/ldbSetting"

const LocalStorageKeyPrefix = 'Setting_'

export const selectStoredSettings = async (): Promise<Result<SettingPersistRow[], FusionError>> => {
	let rows: SettingPersistRow[] = []
	if(Capacitor.isNativePlatform()) {
		const r = await selectLdbSettings()
		if(r.isErr()) {
			return err(r.error)
		}
		rows = r.value
	} else {
		try {
			for(let id of Object.values(SettingId)) {
				if(!settingShouldPersistToLocalStorage(id)) {
					continue
				}
				const value = localStorage.getItem(LocalStorageKeyPrefix + id)
				rows.push({id, value})
			}
		} catch(ex) {
			return err(serializeFusionError('selectStoredSettings', ex))
		}
	}
	return ok(rows)
}

export const updateStoredSettings = async (rows: SettingPersistRow[]): Promise<Result<void, FusionError>> => {
	if(Capacitor.isNativePlatform()) {
		return updateLdbSettings(rows)
	} else {
		try {
			for(let {id, value} of rows) {
				if(!settingShouldPersistToLocalStorage(id)) {
					continue
				}
				if(value) {
					localStorage.setItem(LocalStorageKeyPrefix + id, value)
				} else {
					localStorage.removeItem(LocalStorageKeyPrefix + id)
				}
			}
		} catch(ex) {
			return err(serializeFusionError('updateStoredSettings', ex))
		}
		return ok()
	}
}
